<script setup lang="ts">
import ReviewStars from '~/components/objects/Reviews/ReviewStars.vue'
import CommentAggregate from '~/models/CommentAggregate/CommentAggregate'

defineProps({
    review: {
        type: Object as PropType<CommentAggregate>,
        required: true,
    },
})

const redirectToUrl = async (event: any) => {
    await safeNavigateTo(event.currentTarget.getAttribute('href'))
}
</script>

<template>
    <div class="review_item__wrapper">
        <div class="review_item__title">
            <div class="review_item__title_image">
                <img v-lazy-load src="/nuxt-assets/images/lazy-load-error.svg" :data-src="review.image" width="50" height="50" />
            </div>
            <div class="review_item__title_product" v-html="$t('reviews.productRating', { productName: review.productName })"></div>
        </div>
        <div class="review_item__rating">
            <ReviewStars :rating="review.rating"></ReviewStars>
            <span>{{ review.rating }} / {{ review.totalReviews }}x</span>
        </div>
        <div class="review_item__content">
            <div class="review_item__content_text">
                {{ review.content }}
            </div>
        </div>
        <div class="review_item__button">
            <a :href="review.productLink" class="btn btn-outline-primary add-cart__simple rounded-25" @click.prevent="redirectToUrl">
                {{ $t('reviews.showProduct') }}
            </a>
        </div>
    </div>
</template>

<style scoped lang="scss">
.review_item {
    &__wrapper {
        box-shadow: $box-shadow;
        border-radius: 10px;
        padding: 1rem;
    }

    &__title {
        display: flex;
        align-items: center;
        padding: 0.5rem;
        background-color: $color-grey;
        border-radius: $border-radius;
        font-size: 14px;
        gap: 1rem;
    }

    &__title_image {
        display: flex;
        justify-content: center;
        width: 50px;
        height: 50px;
        margin: 0.5rem;
        flex-shrink: 0;

        img {
            width: auto;
            height: 50px;
        }
    }

    &__rating {
        display: inline-flex;
        flex-wrap: nowrap;
        align-items: center;
        background-color: $color-yellow-light;
        font-size: 12px;
        padding: 0.25rem 1rem;
        border-radius: 50px;
        gap: 0.5rem;
        margin: 1rem 0;
    }

    &__content {
        color: $color-dark;
        font-size: 14px;
        margin-bottom: 1rem;
    }

    &__content_title {
        font-size: 16px;
        font-weight: 590;
        margin-bottom: 1rem;
    }
}
</style>
